export default __webpack_public_path__ + "static/media/FacebookSansBold.acda9a5f.woff";